import { configureStore } from '@reduxjs/toolkit';
import userSlice from './features/user/userSlice';
import textSlice from './features/text/textSlice';
import nftSlice from './features/nft/nftSlice';
import editorSlice from './features/editor/editorSlice';

export const store = configureStore({
  reducer: {
    user: userSlice,
    text: textSlice,
    nft: nftSlice,
    editor: editorSlice,
  },
});
